__turbopack_context__.v({
  "className": "poppins_1bb3ff7-module__b2ua9G__className",
});
